/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MessageAuthorType = {
    Staff: 'staff',
    Participant: 'participant',
} as const;
export type MessageAuthorType = typeof MessageAuthorType[keyof typeof MessageAuthorType];


export function instanceOfMessageAuthorType(value: any): boolean {
    for (const key in MessageAuthorType) {
        if (Object.prototype.hasOwnProperty.call(MessageAuthorType, key)) {
            if (MessageAuthorType[key as keyof typeof MessageAuthorType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MessageAuthorTypeFromJSON(json: any): MessageAuthorType {
    return MessageAuthorTypeFromJSONTyped(json, false);
}

export function MessageAuthorTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageAuthorType {
    return json as MessageAuthorType;
}

export function MessageAuthorTypeToJSON(value?: MessageAuthorType | null): any {
    return value as any;
}

export function MessageAuthorTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): MessageAuthorType {
    return value as MessageAuthorType;
}

